module.exports = __webpack_public_path__ + "assets/assets/images/about/family.268ca090.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/about/family.png
// module id = 546
// module chunks = 0